export default __webpack_public_path__ + "static/char-46-ef0713af7f7b10fb56b8cb53040ceca8.gif";